import React, { useState } from 'react';
import Modal from '../shared/Modal';
import { TextField, SelectField, ToggleField } from '../shared/FormField';
import { buildSpeciesOptions, parseApiError } from '../FoundationalTables/SpeciesLivestockRegistry/registryHelpers';

const blank = {
  species_uuid: '',
  purpose_code: '',
  purpose_label: '',
  seasonal_flag: false,
};

export default function CreateProductionPurposeModal({ isOpen, onClose, onCreate, species = [] }) {
  const [form, setForm] = useState(blank);
  const [status, setStatus] = useState('idle');
  const [errMsg, setErrMsg] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const set = (key) => (value) => setForm((current) => ({ ...current, [key]: value }));

  const speciesOptions = buildSpeciesOptions(species);

  const submit = async () => {
    if (submitting) return;

    if (!form.species_uuid || !form.purpose_code.trim() || !form.purpose_label.trim()) {
      setErrMsg('Please complete the required fields before saving.');
      setStatus('error');
      return;
    }

    setSubmitting(true);
    setStatus('idle');
    setErrMsg('');

    try {
      await onCreate({
        species_uuid: form.species_uuid,
        purpose_code: form.purpose_code.trim(),
        purpose_label: form.purpose_label.trim(),
        seasonal_flag: form.seasonal_flag,
      });
      setStatus('success');
    } catch (error) {
      setErrMsg(parseApiError(error, 'Unable to create production purpose.'));
      setStatus('error');
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    setForm(blank);
    setStatus('idle');
    setErrMsg('');
    setSubmitting(false);
    onClose();
  };

  return (
    <Modal
      title="Create Production Purpose Registry"
      isOpen={isOpen}
      onClose={handleClose}
      onSubmit={submit}
      status={status}
      errorMessage={errMsg}
      onContinue={handleClose}
      submitLabel="Create"
      successTitle="Production Purpose Created"
      successMessage="The production purpose was saved to the backend."
      isSubmitting={submitting}
    >
      <SelectField
        label="Species"
        required
        value={form.species_uuid}
        onChange={set('species_uuid')}
        options={speciesOptions}
        placeholder="Select Species"
      />
      <TextField
        label="Purpose Code"
        required
        value={form.purpose_code}
        onChange={set('purpose_code')}
        placeholder="e.g. beef"
      />
      <TextField
        label="Purpose Label"
        required
        value={form.purpose_label}
        onChange={set('purpose_label')}
        placeholder="e.g. Beef production"
      />
      <ToggleField
        label="Seasonal Flag"
        value={form.seasonal_flag}
        onChange={set('seasonal_flag')}
        note="Toggle on when the purpose is seasonal."
      />
    </Modal>
  );
}
